import { createFileRoute, useParams } from "@tanstack/react-router";
import { Truck } from "lucide-react";
import ExpeditionView from "@/features/ventes/components/expeditions/ExpeditionView";

function ExpeditionViewPage() {
  const { id } = useParams({ from: "/_app/ventes/expeditions/$id/view" });
  return <ExpeditionView expeditionId={id} />;
}

export const Route = createFileRoute("/_app/ventes/expeditions/$id/view")({
  staticData: {
    title: "Détails Expédition",
    icon: Truck,
    showInBreadcrumb: true,
  },
  component: ExpeditionViewPage,
});
